
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic06Off as ObiHydraulic06OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-06-off.js';
 
 
 

 
 export const ObiHydraulic06Off = createComponent({
   react: React,
   tagName: 'obi-hydraulic-06-off',
   elementClass: ObiHydraulic06OffElement,
   events: {
     
   }
  });
 
 